import {
  ContentPermission,
  ContentPermissionListResult,
  GrantContentPermissionInput,
  SetContentPermissionLevelInput,
} from '@vivport/backend/types';
import { httpClient } from './http-client';

export async function listContentPermissions(contentId: number): Promise<ContentPermissionListResult> {
  return httpClient.get<ContentPermissionListResult>(`/protected/content/${contentId}/permissions`);
}

export async function grantContentPermission(
  contentId: number,
  input: GrantContentPermissionInput,
): Promise<ContentPermission> {
  return httpClient.post<ContentPermission, GrantContentPermissionInput>(
    `/protected/content/${contentId}/permissions`,
    input,
  );
}

export async function setContentPermissionLevel(
  contentId: number,
  groupId: number,
  input: SetContentPermissionLevelInput,
): Promise<ContentPermission> {
  return httpClient.patch<ContentPermission, SetContentPermissionLevelInput>(
    `/protected/content/${contentId}/permissions/${groupId}`,
    input,
  );
}

export async function revokeContentPermission(contentId: number, groupId: number): Promise<void> {
  return httpClient.delete<void>(`/protected/content/${contentId}/permissions/${groupId}`);
}
